import { Instance, SnapshotIn, types } from 'mobx-state-tree'
import { baseModel } from 'store/utils/base-model'
import { createStore } from 'store/utils/create-store'
import { getRootStore } from 'store/utils/get-root-store'

export const ProfileSkill = baseModel('profile_skills').props({
  name: types.string,
  description: types.maybeNull(types.string),
  skillType: types.maybeNull(types.string),
})

export interface ProfileSkill extends Instance<typeof ProfileSkill> {}
export type ProfileSkillModelAttributes = SnapshotIn<typeof ProfileSkill>

type ProfileSkillIncludes = never

type ProfileSkillStoreOptions = {
  Include: ProfileSkillIncludes[]
}

export const ProfileSkillStore = createStore<
  typeof ProfileSkill,
  ProfileSkillStoreOptions
>('ProfileSkill', ProfileSkill).views((store) => ({
  forUser(userId: string) {
    const rootStore = getRootStore(store)
    const user = rootStore.users.byId(userId)
    if (!user) return []

    // Filter profile skills that belong to this user
    return store.filtered((profileSkill) =>
      user.profileSkills.some((ps) => ps?.id === profileSkill.id)
    )
  },
}))
